import { useState } from "react";
import { X, Camera } from "lucide-react";
import { GALERIA, CATEGORIAS_FOTOS } from "../data/siteData";

export const Galeria = () => {
  const [categoria, setCategoria] = useState("Todos");
  const [selecionada, setSelecionada] = useState(null);
  const fotos = GALERIA.filter((f) => categoria === "Todos" || f.categoria === categoria);

  return (
    <section id="galeria" className="bg-[#18181C] py-24" data-testid="galeria-section">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="flex items-center gap-2 text-[#DC2626] mb-4">
          <Camera className="h-4 w-4" />
          <p className="text-xs font-semibold uppercase tracking-[0.3em]">Nosso Trabalho</p>
        </div>
        <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-semibold text-[#F8FAF8] tracking-tight" data-testid="galeria-title">
          Galeria de treinos e eventos
        </h2>
        <div className="mt-8 flex flex-wrap gap-2" data-testid="galeria-categorias">
          {CATEGORIAS_FOTOS.map((c) => (
            <button
              key={c}
              onClick={() => setCategoria(c)}
              data-testid={`galeria-filtro-${c.toLowerCase().replace(/ /g, "-")}`}
              className={`text-xs font-semibold px-4 py-2 rounded-full border transition-colors duration-200 ${
                categoria === c
                  ? "bg-[#DC2626] border-[#DC2626] text-white"
                  : "border-white/15 text-zinc-400 hover:border-[#DC2626]/60 hover:text-zinc-200"
              }`}
            >
              {c}
            </button>
          ))}
        </div>
        <div className="mt-10 grid grid-cols-2 lg:grid-cols-3 gap-4">
          {fotos.map((f, i) => (
            <button key={f.src} onClick={() => setSelecionada(f)} data-testid={`galeria-foto-${i + 1}`} className="group relative overflow-hidden rounded-xl border border-white/10 aspect-[4/3] focus:outline-none focus:ring-2 focus:ring-[#DC2626]">
              <img src={f.src} alt={f.titulo} loading="lazy" className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-500" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-4 text-left">
                <div>
                  <p className="text-sm font-semibold text-white">{f.titulo}</p>
                  <p className="text-xs text-zinc-300">{f.categoria}</p>
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>

      {selecionada && (
        <div className="fixed inset-0 z-[60] bg-black/90 flex items-center justify-center p-4" onClick={() => setSelecionada(null)} data-testid="galeria-lightbox">
          <button className="absolute top-5 right-5 text-white/80 hover:text-white" onClick={() => setSelecionada(null)} data-testid="galeria-lightbox-fechar" aria-label="Fechar">
            <X className="h-7 w-7" />
          </button>
          <figure className="max-w-3xl w-full" onClick={(e) => e.stopPropagation()}>
            <img src={selecionada.src} alt={selecionada.titulo} className="w-full max-h-[75vh] object-contain rounded-lg" />
            <figcaption className="mt-4 text-center">
              <p className="text-base font-semibold text-white" data-testid="galeria-lightbox-titulo">{selecionada.titulo}</p>
              <p className="text-sm text-zinc-400">{selecionada.categoria} · {selecionada.data}</p>
            </figcaption>
          </figure>
        </div>
      )}
    </section>
  );
};
